export default __webpack_public_path__ + "static/media/agliveBackground.1a5be4b8.jpg";